// import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web'
// import { configureOpentelemetry } from '@uptrace/web'

// // configureOpentelemetry automatically sets up window.onerror handler.
// const sdk = configureOpentelemetry({
//   // Set dsn or UPTRACE_DSN env var.
//   dsn: 'https://XCe6LMf_XOt1D14VdIhf7Q@api.uptrace.dev?grpc=4317',

//   serviceName: 'ecommerce-web',
//   serviceVersion: '1.0.0',

//   instrumentations: [getWebAutoInstrumentations({})],
// })
// sdk.start()

import { createRoot } from 'react-dom/client'
import App from './App';
import './index.css'
import { BrowserRouter } from 'react-router-dom';
import { SicarLoading } from "@sicarx/sxe-components";
import { configI18n } from "@sicarx/sxe-core"; configI18n();
import { WithAxios } from '@sicarx/sxe-api';




createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <SicarLoading />
    <WithAxios>
      <App />
    </WithAxios>
  </BrowserRouter>
)